module.exports = __webpack_public_path__ + "af.no1.d35e5fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/af.no1.jpg
// module id = Nsyz
// module chunks = 0